import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=4fb0ae0e&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=ts"
export * from "./Cart.vue?vue&type=script&lang=ts"
import style0 from "./Cart.vue?vue&type=style&index=0&id=4fb0ae0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0ae0e",
  null
  
)

export default component.exports